import { render, staticRenderFns } from "./EditOnboardingDocumentsComponent.vue?vue&type=template&id=a03eca08&scoped=true&"
import script from "./EditOnboardingDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./EditOnboardingDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditOnboardingDocumentsComponent.vue?vue&type=style&index=0&id=a03eca08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03eca08",
  null
  
)

export default component.exports